import BaseDecorator from "./BaseDecorator";

export default class PricingPlanDecorator extends BaseDecorator {}



// WEBPACK FOOTER //
// ./src/lib/decorators/PricingPlanDecorator.js